// This URL is used to fetch casino game images from a specific storage bucket.
// It is hardcoded for now because the URL is the same for all environments and
// As we are on a package and not an app we would need to define the env-var on the app that uses this package
export const CASINO_IMAGES_BASE_URL = 'https://storage.googleapis.com/casino-preview-prod/games';

export const randomImagesIds = [
  'relax123boom.jpg',
  'nyx1leftalive.jpg',
  'nyxonemillionmegawaysbc.jpg',
  'eusmd11champions.jpg',
  'ygg12trojanmys.jpg',
];
